import { type ComponentProps, useRef } from 'react';
import Link from 'next/link';
import { useTranslation } from 'next-i18next/pages';
import { SearchResultCard, type TFunction } from '@pkgs/components';
import { getSearchListingResultId, type SearchListingResult } from '@pkgs/api';

import { TRANSLATION_NAMESPACE } from '@/i18n/config';
import { useWatchlist } from '@/hooks/useWatchlist';
import { useUserAcountAuth } from '@/hooks/useUserAcountAuth';
import { useSettings } from '@/hooks/useSettings';
import { useExposePageProps } from '@/hooks/useExposePageProps';

import { ImageComponent } from '../ImageComponent/ImageComponent';

type Props = {
  listingResult: SearchListingResult;
  onClick?: () => void;
};

const LinkWrapper = (props: ComponentProps<typeof Link>) => {
  return <Link {...props} />;
};

export const SearchResultCardWrapper = ({ listingResult, onClick }: Props) => {
  const { t: tPropertyCard } = useTranslation(TRANSLATION_NAMESPACE.property_card);
  const { t: tPropertyExpose } = useTranslation(TRANSLATION_NAMESPACE.property_expose);
  const { measurementSystem, currency, countryCode, language } = useSettings();
  const { handleWatchlistClick, getIsInWatchlist } = useWatchlist();
  const cardElementRef = useRef<HTMLDivElement | null>(null);
  const { openUserAccountModal } = useUserAcountAuth();
  const { promotedBy } = useExposePageProps();
  const linkParams = promotedBy ? { promotedBy } : undefined;

  return (
    <SearchResultCard
      ref={cardElementRef}
      linkComponent={LinkWrapper}
      language={language}
      imageComponent={ImageComponent}
      onClickPropertyCardLink={onClick}
      listingResult={listingResult}
      onWatchlistClick={handleWatchlistClick}
      isInWatchlist={getIsInWatchlist(getSearchListingResultId(listingResult))}
      currency={currency}
      measurementSystem={measurementSystem}
      translationResolver={tPropertyCard as TFunction}
      countryCode={countryCode}
      linkParams={linkParams}
      aiBadgeTranslationKey="search.expose.photoGallery.label.ai"
      aiBadgeTranslationResolver={tPropertyExpose as TFunction}
      openUserAccountModal={openUserAccountModal}
    />
  );
};
